export default "__VITE_ASSET__ChJww8jO__"